export default __webpack_public_path__ + "static/media/english-to-hungarian-screenshot-01.6637ef17.png";